<template>
  <div class="lifecycle-page" role="status" aria-live="polite">
    <div class="lifecycle-card">
      <img :src="brand.assets.logoMark" alt="" class="lifecycle-logo" />
      <span class="lifecycle-spinner" aria-hidden="true"></span>
      <h1>Signing you out</h1>
      <p>Closing your local session securely.</p>
    </div>
  </div>
</template>

<script>
import { onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { clearCache } from "@/composables/cache/logout";
import brand from "@/whitelabel/brand.config";

export default {
  name: "LogoutHome",
  setup() {
    const router = useRouter();
    let logoutTimer = null;

    onMounted(() => {
      document.title = `Signing out | ${brand.productName}`;
      logoutTimer = window.setTimeout(async () => {
        await clearCache();
        router.replace({ name: "login" });
      }, 300);
    });

    onUnmounted(() => window.clearTimeout(logoutTimer));

    return { brand };
  },
};
</script>

<style scoped>
.lifecycle-page {
  align-items: center;
  background: var(--ui-muted);
  display: flex;
  inset: 0;
  justify-content: center;
  min-height: 100vh;
  padding: 1.25rem;
  position: fixed;
  z-index: 999;
}
.lifecycle-card {
  align-items: center;
  background: var(--ui-card);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius);
  box-shadow: var(--ui-shadow-sm);
  color: var(--ui-card-foreground);
  display: flex;
  flex-direction: column;
  max-width: 24rem;
  padding: 2.25rem;
  text-align: center;
  width: 100%;
}
.lifecycle-logo { height: 3rem; margin-bottom: 1.5rem; width: 3rem; }
.lifecycle-spinner {
  animation: lifecycle-spin 750ms linear infinite;
  border: 3px solid var(--ui-border);
  border-radius: 50%;
  border-top-color: var(--ui-primary);
  height: 2.5rem;
  width: 2.5rem;
}
.lifecycle-card h1 { font-size: 1.15rem; font-weight: 700; margin: 1.25rem 0 0; }
.lifecycle-card p { color: var(--ui-muted-foreground); font-size: 0.84rem; margin: 0.45rem 0 0; }
@keyframes lifecycle-spin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { .lifecycle-spinner { animation-duration: 1.5s; } }
</style>
